export default {
  ai_explanation: {
    title: "Как работает система Estimator24",
    intro:
      "Estimator24 использует искусственный интеллект и анализ данных, чтобы определить справедливую рыночную стоимость недвижимости на основе десятков факторов.",
    how_it_works: {
      title: "Как рассчитывается цена",
      step1: "Система находит похожие квартиры в радиусе до 20 км.",
      step2: "Анализирует характеристики: площадь, этаж, год постройки, вид, инфраструктуру.",
      step3: "Несколько моделей машинного обучения рассчитывают прогнозы независимо друг от друга.",
      step4: "Итоговая цена — это взвешенное среднее с учётом рыночных тенденций."
    },
    models: {
      title: "Модели Estimator24",
      xgboost: "Комплексная модель, анализирующая все доступные параметры.",
      lightgbm: "Сравнивает объект с ближайшими аналогами по характеристикам.",
      randomforest: "Определяет редкие комбинации признаков и недооценённые объекты.",
      neural: "Нейросеть, обученная на исторических данных и фотографиях объектов.",
      regression: "Статистическая модель, отражающая общую рыночную динамику."
    },
    market: {
      title: "Что значит «ниже» или «выше рынка»",
      desc: "Если цена объекта ниже средней по району — это может быть выгодная покупка. Если выше — возможно, цена отражает лучшее состояние, вид или локацию. Estimator24 сравнивает все данные, чтобы показать реальное положение на рынке."
    }
  }
}
